<template>
  <div>
    <van-tabbar fixed class="footNav">
      <van-tabbar-item to="/user">
        <span :class="{'theme-col':router == 'User'}">积分兑换</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-shouye" :class="{'theme-col':router == 'User'}"/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/goodslist">
        <span :class="{'theme-col':router == 'GoodsList'}">商品列表</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-fenlei" :class="{'theme-col':router == 'GoodsList'}"/>
        </template>
      </van-tabbar-item>
      <!--<van-tabbar-item to="/user/cart">-->
        <!--<span :class="{'theme-col':router == 'Cart'}">兑换袋</span>-->
        <!--<template slot="icon" slot-scope="props">-->
          <!--<van-icon class="iconfont icon-gouwuche" :class="{'theme-col':router == 'Cart'}"/>-->
        <!--</template>-->
      <!--</van-tabbar-item>-->
      <van-tabbar-item to="/" class="theme-col">
        <span :class="{'theme-col':router == 'Home'}">个人中心</span>
        <template slot="icon" slot-scope="props">
          <van-icon class="iconfont icon-wode " :class="{'theme-col':router == 'Home'}"/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: "footernav",
    data(){
      return{

      }
    },
    computed:{
      router:function () {
        return this.$route.name
      }
    }
  }
</script>

<style lang="less" scoped>
.footNav{
  padding: 3px 0 3px;
  .van-tabbar{
    height: auto;
  }
  .van-icon{
    font-size: 2rem;
  }
  .van-tabbar-item__text{
    span{
      font-size: 1.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footernav.vue